import { ForgotPasswordState, FORGOT_PASSWORD_FEATURE_KEY } from "./forgot-password.reducer";
import { createFeatureSelector, createSelector } from "@ngrx/store";

export const getForgotPasswordState = createFeatureSelector<ForgotPasswordState>(FORGOT_PASSWORD_FEATURE_KEY);

export const selectIsLoading = createSelector(getForgotPasswordState, (state: ForgotPasswordState) => state.loading);

export const selectSucceeded = createSelector(getForgotPasswordState, (state: ForgotPasswordState) => {
    return {succeeded: state.succeeded, email: state.email}
});

export const selectIsFailure = createSelector(getForgotPasswordState, (state: ForgotPasswordState) => state.error);